<template>
  <Layout :instruction="instruction">
    <template v-slot:title>
      <div><span v-if="!isEditMode">Create new</span> Yes/No instruction</div>
    </template>
    <template v-slot:content>
      <div class="content-wrapper">
        <b-field class="full-width">
          <b-input
            type="textarea"
            v-model="question"
            :disabled="loading"
          ></b-input>
        </b-field>
        <b-field>
          <b-checkbox v-model="pictureMandatory">
            Picture taken is mandatory.</b-checkbox
          >
        </b-field>
      </div>
    </template>
    <template v-slot:reference-image>
      <ReferenceImage :instructionProps="instruction" ref="refImage" />
    </template>
    <template v-slot:footer>
      <b-loading
        :is-full-page="true"
        v-model="loading"
        :can-cancel="false"
      ></b-loading>
      <b-button
        :disabled="!instruction"
        type="is-danger"
        @click="$emit('onDelete')"
        >Delete</b-button
      >
      <b-button type="is-link" @click="$emit('onCancel')">Cancel</b-button>
      <b-button
        v-if="!instruction"
        type="is-success"
        :disabled="loading"
        @click="onSave"
        :loading="loadingButton"
        >Save</b-button
      >
      <b-button
        v-if="instruction"
        type="is-success"
        @click="onUpdate"
        :loading="loadingButton"
        >Update</b-button
      >
    </template>
  </Layout>
</template>

<script>
import Layout from './layout';
import ReferenceImage from '../ReferenceImage';
import { GET_LOADING_STATE } from '../../../../../store/loading/getters/getterTypes';
import KeyHandlerMixin from '../../../../../mixins/KeyHandlerMixin';

export default {
  name: 'yesno',
  components: {
    Layout,
    ReferenceImage,
  },
  mixins: [KeyHandlerMixin],
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    instruction: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    if (this.instruction) {
      this.question = this.instruction.question;
      this.pictureMandatory = this.instruction.isPictureMandatory;
    }

    if (this.instruction) {
      this.setKeyHandlerCallback('update', this.onUpdate);
    } else {
      this.setKeyHandlerCallback('save', this.onSave);
    }
  },
  watch: {
    instruction(newVal) {
      if (newVal) {
        this.question = newVal.question;
      }
    },
  },
  data() {
    return {
      question: '',
      pictureMandatory: false,
      loadingButton: false,
    };
  },
  methods: {
    onSave() {
      const file = this.$refs.refImage?.file;
      const useImageReference = this.$refs.refImage?.useImageReference;
      this.loadingButton = true;
      this.$emit('onSave', {
        question: this.question,
        isPictureMandatory: this.pictureMandatory,
        type: 'yesno',
        yesOrNo: '',
        description: 'Yes/No',
        file,
        useImageReference,
      });
    },
    onUpdate() {
      const file = this.$refs.refImage?.file;
      const useImageReference = this.$refs.refImage?.useImageReference;
      this.loadingButton = true;
      this.$emit('onUpdate', {
        _id: this.instruction._id,
        ...this.instruction,
        question: this.question,
        isPictureMandatory: this.pictureMandatory,
        type: 'yesno',
        file,
        useImageReference,
      });
    },
  },
  computed: {
    loading() {
      return this.$store.getters[GET_LOADING_STATE];
    },
  },
};
</script>

<style scoped>
button {
  flex: 1;
}

.content-wrapper {
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 40px;
}

.full-width {
  width: 100%;
}
</style>
